// extracted by mini-css-extract-plugin
export var dropdown = "_ei-0";
export var imagePlaceholder = "_ei-2";
export var imageWrapper = "_ei-3";
export var productImage = "_ei-1";
export var truncateContainer = "_ei-4";
export var truncateText = "_ei-5";